<ng-container *ngIf="kunde">
  <ng-container *ngIf="environment.type == 'web'">
    <rechnungenWbp [rechnungen]="rechnungen" [mandant]="mandant"></rechnungenWbp>
  </ng-container>
  <ng-container  *ngIf="environment.type != 'web'">
    <rechnungenWba [rechnungen]="rechnungen" [mandant]="mandant"></rechnungenWba>
  </ng-container>
  <div id="rechnungenLeer" *ngIf="kunde.rechnungsdaten == ''" [class.web]="environment.type == 'web'">
    <mat-icon>receipt_long</mat-icon>
  </div>
</ng-container>

